import { styled } from '@mui/material';

export const StyledContent = styled('div')(() => ({
  flex: 1
}));
